/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteNotification } from '../fn/notifications/delete-notification';
import { DeleteNotification$Params } from '../fn/notifications/delete-notification';
import { getNotifications } from '../fn/notifications/get-notifications';
import { GetNotifications$Params } from '../fn/notifications/get-notifications';
import { GetNotificationSettingsResult } from '../models/get-notification-settings-result';
import { GetNotificationsResult } from '../models/get-notifications-result';
import { getSettings } from '../fn/notifications/get-settings';
import { GetSettings$Params } from '../fn/notifications/get-settings';
import { getUnreadCount } from '../fn/notifications/get-unread-count';
import { GetUnreadCount$Params } from '../fn/notifications/get-unread-count';
import { GetUnreadNotificationsCountResult } from '../models/get-unread-notifications-count-result';
import { postOptInSettings } from '../fn/notifications/post-opt-in-settings';
import { PostOptInSettings$Params } from '../fn/notifications/post-opt-in-settings';
import { postRegisterDevice } from '../fn/notifications/post-register-device';
import { PostRegisterDevice$Params } from '../fn/notifications/post-register-device';
import { postSetAsRead } from '../fn/notifications/post-set-as-read';
import { PostSetAsRead$Params } from '../fn/notifications/post-set-as-read';
import { postSettings } from '../fn/notifications/post-settings';
import { PostSettings$Params } from '../fn/notifications/post-settings';
import { postUnregisterDevice } from '../fn/notifications/post-unregister-device';
import { PostUnregisterDevice$Params } from '../fn/notifications/post-unregister-device';

@Injectable({ providedIn: 'root' })
export class ApiNotificationsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteNotificationsNotification()` */
  static readonly DeleteNotificationsNotificationPath = '/Notifications/notification';

  /**
   * delete-notifications-notification.
   *
   * Delete Notifications<br>Delete notification by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteNotification()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteNotification$Response(params?: DeleteNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * delete-notifications-notification.
   *
   * Delete Notifications<br>Delete notification by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteNotification$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteNotification(params?: DeleteNotification$Params, context?: HttpContext): Observable<void> {
    return this.deleteNotification$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getNotifications()` */
  static readonly GetNotificationsPath = '/Notifications';

  /**
   * get-notifications.
   *
   * Get Notifications<br>Get all notifications for authenticated user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotifications$Response(params?: GetNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotificationsResult>> {
    return getNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * get-notifications.
   *
   * Get Notifications<br>Get all notifications for authenticated user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotifications(params?: GetNotifications$Params, context?: HttpContext): Observable<GetNotificationsResult> {
    return this.getNotifications$Response(params, context).pipe(map((r: StrictHttpResponse<GetNotificationsResult>): GetNotificationsResult => r.body));
  }

  /** Path part for operation `getNotificationsSettings()` */
  static readonly GetNotificationsSettingsPath = '/Notifications/settings';

  /**
   * get-notifications-settings.
   *
   * Get Notifications settings<br>Get all notifications settings for authenticated user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings$Response(params?: GetSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNotificationSettingsResult>> {
    return getSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * get-notifications-settings.
   *
   * Get Notifications settings<br>Get all notifications settings for authenticated user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings(params?: GetSettings$Params, context?: HttpContext): Observable<GetNotificationSettingsResult> {
    return this.getSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetNotificationSettingsResult>): GetNotificationSettingsResult => r.body),
    );
  }

  /** Path part for operation `postNotificationsSettings()` */
  static readonly PostNotificationsSettingsPath = '/Notifications/settings';

  /**
   * post-notifications-settings.
   *
   * Update Notification settings<br>Update Notification settings for a specified type
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSettings()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSettings$Response(params?: PostSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * post-notifications-settings.
   *
   * Update Notification settings<br>Update Notification settings for a specified type
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSettings$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSettings(params?: PostSettings$Params, context?: HttpContext): Observable<void> {
    return this.postSettings$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `getNotificationsUnreadCount()` */
  static readonly GetNotificationsUnreadCountPath = '/Notifications/unread-count';

  /**
   * get-notifications-unread-count.
   *
   * Get unread notifications count<br>Get all notifications for authenticated user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnreadCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnreadCount$Response(params?: GetUnreadCount$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUnreadNotificationsCountResult>> {
    return getUnreadCount(this.http, this.rootUrl, params, context);
  }

  /**
   * get-notifications-unread-count.
   *
   * Get unread notifications count<br>Get all notifications for authenticated user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnreadCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnreadCount(params?: GetUnreadCount$Params, context?: HttpContext): Observable<GetUnreadNotificationsCountResult> {
    return this.getUnreadCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUnreadNotificationsCountResult>): GetUnreadNotificationsCountResult => r.body),
    );
  }

  /** Path part for operation `postNotificationsRegisterDevice()` */
  static readonly PostNotificationsRegisterDevicePath = '/Notifications/register-device';

  /**
   * post-notifications-register-device.
   *
   * Register device for push notifications<br>Register device for push notifications
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postRegisterDevice()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRegisterDevice$Response(params?: PostRegisterDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postRegisterDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * post-notifications-register-device.
   *
   * Register device for push notifications<br>Register device for push notifications
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postRegisterDevice$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRegisterDevice(params?: PostRegisterDevice$Params, context?: HttpContext): Observable<void> {
    return this.postRegisterDevice$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `postNotificationsSetAsRead()` */
  static readonly PostNotificationsSetAsReadPath = '/Notifications/set-as-read';

  /**
   * post-notifications-set-as-read.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSetAsRead()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSetAsRead$Response(params?: PostSetAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postSetAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * post-notifications-set-as-read.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSetAsRead$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSetAsRead(params?: PostSetAsRead$Params, context?: HttpContext): Observable<void> {
    return this.postSetAsRead$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `postNotificationsUnregisterDevice()` */
  static readonly PostNotificationsUnregisterDevicePath = '/Notifications/unregister-device';

  /**
   * post-notifications-unregister-device.
   *
   * Unregister device for push notifications<br>Unregister device for push notifications
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUnregisterDevice()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postUnregisterDevice$Response(params?: PostUnregisterDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postUnregisterDevice(this.http, this.rootUrl, params, context);
  }

  /**
   * post-notifications-unregister-device.
   *
   * Unregister device for push notifications<br>Unregister device for push notifications
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUnregisterDevice$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postUnregisterDevice(params?: PostUnregisterDevice$Params, context?: HttpContext): Observable<void> {
    return this.postUnregisterDevice$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `postNotificationsOptInSettings()` */
  static readonly PostNotificationsOptInSettingsPath = '/Notifications/opt-in-settings';

  /**
   * post-notifications-opt-in-settings.
   *
   * Update OptIn settings<br>Update OptIn settings
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postOptInSettings()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postOptInSettings$Response(params?: PostOptInSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postOptInSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * post-notifications-opt-in-settings.
   *
   * Update OptIn settings<br>Update OptIn settings
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postOptInSettings$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postOptInSettings(params?: PostOptInSettings$Params, context?: HttpContext): Observable<void> {
    return this.postOptInSettings$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
